__webpack_require__.p = "/api/cdn/public/static-assets/";